module.exports = __webpack_public_path__ + "media/images/logo/ok-d2736c605fd6f7bb1878d7fe1f2c940e.svg";